const adress = [
  {
    id: 1,
    isOpen: true,
    city: "Toruń",
    street: "ul. Mostowa 36",
    tel: "+48505635671",
    openHours1: "13:00 - 22:00",
    openHours2: "13:00 - 01:00",
    openHours3: "13:00 - 22:00",
    imgPath: "",
    appLink: "/torun",
    socialMedia: {
      fb: "https://www.facebook.com/steakhousesubstancja",
      insta: "https://www.instagram.com/steakhouse.whitebull/",
      tiktok: "",
    },
    apartments: [
      {
        apartStreet: "ul. Mostowa 36,",
        apartCity: "Toruń",
        apartPost: "87-100",
        apartTel: "+48505635671",
        apartEmail: "torun-apartamenty@whitebull.com.pl",
        apartBooking: "https://booking.com",
        apartImages: [],
      },
    ],
  },
  {
    id: 2,
    isOpen: true,
    city: "Bydgoszcz",
    street: "ul. Poznańska 8",
    tel: "+48453293882",
    openHours1: "13:00 - 22:00",
    openHours2: "13:00 - 01:00",
    openHours3: "13:00 - 22:00",
    imgPath: "",
    appLink: "/bydgoszcz",
    socialMedia: {
      fb: "https://www.facebook.com/profile.php?id=61574858188437",
      insta: "https://www.instagram.com/whitebull_bydgoszcz/",
      tiktok: "https://www.tiktok.com/@whitebull_bydgosz",
    },
    apartments: [],
  },
  {
    id: 3,
    isOpen: true,
    city: "Gdańsk",
    street: "ul. Chmielna 109",
    tel: "+48518789335",
    openHours1: "14:00 - 23:00",
    openHours2: "12:00 - 00:00",
    openHours3: "12:00 - 22:00",
    imgPath: "",
    appLink: "/gdansk",
    socialMedia: {
      fb: "https://www.facebook.com/profile.php?id=61581430367529",
      insta: "https://www.instagram.com/whitebull_gdansk/",
      tiktok: "https://www.tiktok.com/@whitebull_gdansk",
    },
    apartments: [],
  },
];

export default adress;
